import React from 'react';
import { useLanguage } from '../i18n/useLanguage';

interface LanguageToggleProps {
  className?: string;
  style?: React.CSSProperties;
}

export function LanguageToggle({ className, style }: LanguageToggleProps) {
  const { language, toggleLanguage, t } = useLanguage();
  
  // Show current language flag (DE flag when German is active, UK flag when English is active)
  const currentFlag = language === 'de' ? '🇩🇪' : '🇬🇧';
  const ariaLabel = language === 'de' 
    ? t('language.switchTo.en')
    : t('language.switchTo.de');
  
  return (
    <button
      onClick={toggleLanguage}
      className={`language-toggle ${className || ''}`}
      style={{
        border: 'none',
        background: 'transparent',
        cursor: 'pointer',
        fontSize: '24px',
        padding: '4px 8px',
        transition: 'transform 0.2s ease',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}
      aria-label={ariaLabel}
      title={ariaLabel}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'scale(1.1)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
      }}
    >
      <span role="img" aria-label={`${language === 'de' ? 'German' : 'English'} flag`}>
        {currentFlag}
      </span>
    </button>
  );
}
